var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCutlery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9355 52.8203C42.8442 52.8203 52.4981 43.1665 52.4981 31.2578C52.4981 19.3491 42.8442 9.69531 30.9355 9.69531C19.0269 9.69531 9.37305 19.3491 9.37305 31.2578C9.37305 43.1665 19.0269 52.8203 30.9355 52.8203Z",
    fill: "#CE2600",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9414 46.2578C39.2257 46.2578 45.9414 39.5421 45.9414 31.2578C45.9414 22.9735 39.2257 16.2578 30.9414 16.2578C22.6571 16.2578 15.9414 22.9735 15.9414 31.2578C15.9414 39.5421 22.6571 46.2578 30.9414 46.2578Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7855 12.1528C12.073 12.1528 11.5105 12.734 11.5105 13.4278V18.4715C11.5105 18.8465 11.2105 19.1277 10.8543 19.1277C10.4793 19.1277 10.198 18.8278 10.198 18.4715V13.484C10.198 12.7903 9.6543 12.1715 8.96055 12.1528C8.2293 12.134 7.62928 12.7153 7.62928 13.4278V18.4715C7.62928 18.8465 7.3293 19.1277 6.97305 19.1277C6.59805 19.1277 6.3168 18.8278 6.3168 18.4715V13.484C6.3168 12.7903 5.77303 12.1715 5.07928 12.1528C4.34803 12.134 3.74805 12.7153 3.74805 13.4278V22.0152C3.74805 23.7074 4.56791 25.2149 5.82705 26.1569C6.95428 26.7927 6.95428 29.7027 6.95428 29.7027V48.4902C6.95428 49.4652 7.74178 50.2527 8.71678 50.2527H9.14803C10.123 50.2527 10.9105 49.4652 10.9105 48.4902V29.7027C10.9105 29.7027 10.9105 26.9063 12.0378 26.1569C13.2969 25.2149 14.1168 23.7074 14.1168 22.0152V13.4278C14.0793 12.734 13.498 12.1528 12.7855 12.1528Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1755 12.1523C54.863 12.1523 56.2318 13.521 56.2318 15.2085L56.2316 48.5087C56.2316 49.4837 55.4441 50.2712 54.4691 50.2712H54.0378C53.0628 50.2712 52.2753 49.4837 52.2753 48.5087V32.3518C50.1673 31.3985 48.8068 29.2954 48.8068 26.946V16.5398C48.788 14.1211 50.738 12.1523 53.1755 12.1523Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutlery);
export default __webpack_public_path__ + "static/media/cutlery.ab1e88efa72d51220d3d9e4dc215f0bc.svg";
export { ForwardRef as ReactComponent };